import { t } from '../i18n/index.js';
import { IC, closeSheet, esc, render, sheet, toast } from '../ui.js';
import { isIOS, isMobile, isStandalone } from './push.js';

/* "Install app" on phones. Android/Chrome: the browser's own one-tap prompt.
   iPhone: Safari has no prompt, so a short sheet shows the two taps. Desktop: nothing. */
let deferred=null;
const rr=()=>{try{render()}catch(e){}};
export function initInstall(){
  window.addEventListener('beforeinstallprompt',e=>{e.preventDefault();deferred=e;rr()});
  window.addEventListener('appinstalled',()=>{deferred=null;toast(t('inst.done'));rr()});
}
export const showInstall=()=>isMobile()&&!isStandalone();
export async function installApp(){
  if(deferred){const d=deferred;deferred=null;try{d.prompt();await d.userChoice}catch(e){}rr();return}
  openInstallSteps();
}
const SHARE='<svg viewBox="0 0 24 24"><path d="M12 3.5v11M8 7l4-3.5L16 7"/><path d="M5 12.5v6a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-6"/></svg>';
const ADD='<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="4"/><path d="M12 8.5v7M8.5 12h7"/></svg>';
export function openInstallSteps(){
  const ios=isIOS();
  const steps=ios?[[SHARE,t('inst.ios1')],[ADD,t('inst.ios2')],[IC.bolt,t('inst.ios3')]]
                 :[['<b>⋮</b>',t('inst.and1')],[ADD,t('inst.and2')],[IC.bolt,t('inst.ios3')]];
  const b=sheet(`<div class="sheethead"><h2>${t(ios?'inst.iosTitle':'inst.btn')}</h2><button class="iconbtn" data-a="x" aria-label="${esc(t('c.close'))}">${IC.x}</button></div>
  <div class="sheetbody"><ol class="steps">${steps.map(([ic,txt])=>`<li><span class="stepic">${ic}</span><span>${esc(txt)}</span></li>`).join('')}</ol></div>`);
  b.querySelector('[data-a=x]').onclick=()=>closeSheet(b);
}
